import React from 'react';
import './Header.css';

function Header() {
  return <div className="jumbotron text-center" />;
}

export default Header;
